export const createState = () => ({
    id: null,
    communityId: null,
    title: '',
    description: '',
    status: 'draft',
    starts: null,
    ends: null,
    ticketsUrl: null,
    ticketsNote: null,
    ticketsOnSale: null,
    heroAttachmentId: null,
    vanityName: null,
    themeSettings: [],
    stops: [],
    faqs: [],
    alerts: [],
});
// communityId is a create-time choice only, so an edit leaves it unset and the update ignores it.
export const toForm = (tour) => ({
    id: tour.id,
    communityId: null,
    title: tour.title,
    description: tour.description,
    status: tour.status,
    starts: tour.starts,
    ends: tour.ends,
    ticketsUrl: tour.ticketsUrl,
    ticketsNote: tour.ticketsNote,
    ticketsOnSale: tour.ticketsOnSale,
    heroAttachmentId: tour.heroAttachmentId,
    vanityName: tour.vanityName,
    themeSettings: tour.themeSettings,
    stops: tour.stops.map(stop => ({ propertyId: stop.propertyId, parcelViewId: stop.parcelViewId })),
    faqs: tour.faqs.map(faq => ({ question: faq.question, answer: faq.answer })),
    alerts: tour.alerts.map(alert => ({ id: alert.id, message: alert.message, sendAt: alert.sendAt, email: alert.email, text: alert.text })),
});
// Whether a stop has a heart: once the tour names its address, which the heart saves, and only while
// it is published. Visitors are never given an unpublished stop's address; a preview is, and a heart
// there would fail wherever nothing on the address is public yet, which the server requires of a save.
export const hasHeart = (stop) => stop.status === 'published' && stop.parcelId !== null;
